(function($){
    'use strict'; 
    $(document).ready(function() {
      //Play video on carousel
      if($('.carousel').length > 0) {
        if($('.carousel-indicators li').length == 1) {
          $('.carousel-indicators').hide();
        }
        //Bootstrap carousel
        $('.carousel').carousel('pause');
        $('.carousel .modal').on('show.bs.modal', function (event) {
          $(this).closest('.carousel').toggleClass('modal-active');
        });
        $('.carousel .modal').on('hidden.bs.modal', function (event) {
          $(this).closest('.carousel').toggleClass('modal-active');
        });
      }
      //Autoplay video in modal
      if( $(this).find("iframe.video-iframe").length > 0 ){
        $('.modal').on('show.bs.modal', function (event) {
          var symbol = $(this).find(".video-iframe")[0].src.indexOf("?") > -1 ? "&" : "?";
          var url = ($(this).find(".video-iframe")[0].src != 'undefined') ? $(this).find(".video-iframe")[0].src : '#';
          if(!checkAutoPlay(url)) {
            url += symbol + "autoplay=1";
            $(this).find(".video-iframe")[0].src = url;
          }
        });
        $('.modal').on('hidden.bs.modal', function (event) {
          var url = ($(this).find(".video-iframe")[0].src != 'undefined') ? $(this).find(".video-iframe")[0].src : '#';
          if(checkAutoPlay(url)) {
            $(this).find(".video-iframe")[0].src = removeURLParameter(url, 'autoplay');
          }
        });
    }
    if( $(this).find(".auto-play-video").length > 0 ){
      $('.modal').on('show.bs.modal', function (event) {
        var symbol = $(this).find("iframe")[0].src.indexOf("?") > -1 ? "&" : "?";
        var url = ($(this).find("iframe")[0].src != 'undefined') ? $(this).find("iframe")[0].src : '#';
        if(!checkAutoPlay(url)) {
          url += symbol + "autoplay=1";
          $(this).find("iframe")[0].src = url;
        }
      });
      $('.modal').on('hidden.bs.modal', function (event) {
        var url = ($(this).find("iframe")[0].src != 'undefined') ? $(this).find("iframe")[0].src : '#';
        if(checkAutoPlay(url)) {
          $(this).find("iframe")[0].src = removeURLParameter(url, 'autoplay');
        }
      });
  }
      //Carousel slider
      $('.sliders').not('.slick-initialized').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
            infinite: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-left fa-w-6 fa-3x"><path fill="currentColor" d="M25.1 247.5l117.8-116c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L64.7 256l102.2 100.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.7 4.7-12.3 4.7-17 0L25 264.5c-4.6-4.7-4.6-12.3.1-17z" class=""></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" class="svg-inline--fa fa-angle-right fa-w-6 fa-3x"><path fill="currentColor" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z" class=""></path></svg></button>',
        responsive: [
            {
              breakpoint: 1201,
              settings: {
                centerPadding: '20px',
                slidesToShow: 3
              }
            },
            {
              breakpoint: 577,
              settings: {
                centerPadding: '0',
                slidesToShow: 1
              }
            }
          ]
        }).on('setPosition', function (event, slick) {
          const slides = slick.$slides;
          const imgHeight = slick.$slider[0].clientHeight;
          slides.each(function(slide){
              const src = $(this).find('img').hide().attr('src');
              $(this).css({
                  backgroundImage:'url('+src+')',
                  minHeight: imgHeight,
                  backgroundSize: "cover",
                  backgroundPosition: "center"
              });
          });
      });
      function checkAutoPlay($url){
        var autoplay = $url.indexOf('autoplay');
        if(autoplay == '-1') {
          return false;
        }
        return true;
      }
      function removeURLParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');   
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {    
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                    pars.splice(i, 1);
                }
            }

            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
      }

      //Fix error
      if (typeof Object.assign != 'function') {
        Object.assign = function(target) {
          'use strict';
          if (target == null) {
            throw new TypeError('Cannot convert undefined or null to object');
          }

          target = Object(target);
          for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source != null) {
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
          }
          return target;
        };
      }
	});
})(jQuery);